/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import * as S from './styles';
import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import { PLAN_TYPES } from '../../../utils/constants';
import { fireAuth, fireFunctions, fireStore } from '../../../database/utils/firebase';
import { CreditCard } from '../../molecules/CreditCard';
import VerSpacer from '../../atoms/VerSpacer';
// import { fireAuth, fireStore } from '../../../database/utils/firebase';

const Button = styled.button`
  border: none;
  border-radius: 10px;
  background: #009fea;
  color: #fff;
  font-size: 22px;
  margin-top: 30px;
  margin-bottom: 60px;
  padding: 15px 60px;
`;
const plans = {
  pln_D6DF744B6432206D: {
    id: 'pln_D6DF744B6432206D',
    createdOn: '2021-06-14 13:28:44',
    name: 'Plano Teste',
    frequency: 'MONTHLY',
    status: 'ACTIVE',
    amount: 10.0,
    _links: {
      self: {
        href: 'https://sandbox.boletobancario.com/api-integration/plans/pln_D6DF744B6432206D'
      }
    }
  },
  pln_F738DBB1929E59C7: {
    id: 'pln_F738DBB1929E59C7',
    createdOn: '2021-06-15 14:53:59',
    name: 'Plano Teste',
    frequency: 'MONTHLY',
    status: 'ACTIVE',
    amount: 10.0,
    _links: {
      self: {
        href: 'https://sandbox.boletobancario.com/api-integration/plans/pln_F738DBB1929E59C7'
      }
    }
  }
};

const UserPayment = () => {
  const [creditCards, setCreditCards] = useState([]);
  const [plan, setPlan] = useState('');
  const [planDuration, setPlanDuration] = useState(1);
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeSub, setActiveSub] = useState(null);
  // const [credits, setCredits] = useState([]);
  // const [transactions, setTransactions] = useState([]);
  // const uid = fireAuth.currentUser.uid;
  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    refresh();
  }, [fireAuth.currentUser]);

  const refresh = async () => {
    const user = fireAuth.currentUser;

    if (!user?.uid) return;
    const userDoc = fireStore.collection('usuarios').doc(user?.uid);

    await userDoc
      .collection('creditCards')
      .get()
      .then((res) => {
        const tempCards = [];
        res.docs.forEach((card) => {
          tempCards.push(card.data());
        });
        setCreditCards(tempCards);
      })
      .catch((err) => console.log(err));

    await userDoc
      .collection('subscription')
      .get()
      .then((res) => {
        const tempSubs = [];
        res.docs.forEach((card) => {
          tempSubs.push(card.data());
        });
        const hasActive = tempSubs.find((item) => item.status === 'ACTIVE');
        setActiveSub(hasActive);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    try {
      console.log('here');
      if (activeSub && creditCards.length > 0) {
        console.log('has content');
        const savedCard = creditCards.find((card) => card.creditCardId === activeSub.creditCardId);
        console.log(creditCards);
        setPlan(activeSub.planId);
        setSelectedCard(savedCard);
      }
    } catch (error) {
      console.log(error);
    }
  }, [activeSub, creditCards]);

  function updateSelectedPlanCss(planID) {
    try {
      document.getElementById('div_plan_basic').className = 'signup-plan-card';
    } catch (error) {
      console.log(error);
    }
    try {
      document.getElementById('div_plan_standard').className = 'signup-plan-card';
    } catch (error) {
      console.log(error);
    }
    try {
      document.getElementById('div_plan_premium').className = 'signup-plan-card';
    } catch (error) {
      console.log(error);
    }
    if (!planID) return;
    document.getElementById(planID).classList.add('signup-plan-card-selected');
  }

  const expirationDate = useMemo(() => {
    const d = new Date();
    d.setMonth(Number(d.getMonth()) + Number(planDuration));
    const str = d.toISOString();
    const arr = str.split('T')[0].split('-');
    return `${arr[2]}/${arr[1]}/${arr[0]}`;
  }, [planDuration]);

  const handleSign = async () => {
    try {
      setLoading(true);
      const user = await fireAuth.currentUser;
      const createSubscription = fireFunctions.httpsCallable('createSubscription');
      const data = {
        planId: plan,
        userId: user.uid,
        creditCardId: selectedCard.creditCardId,
        dueDay: 5
      };

      const result = await createSubscription(data);
      window.location.reload();
      console.log(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />
          <S.UserPaymentRightContainer>
            <S.UserPaymentTitle>
              <i className="fas fa-shopping-basket" />
              PAGAMENTOS
            </S.UserPaymentTitle>
            <S.UserPaymentTopContainer>
              <S.SecondaryTopLeftContainer>
                <S.TitleAndSearch>
                  <h4 style={{ color: '#002666' }}>MOVIMENTAÇÃO</h4>
                  <div id="divBusca">
                    <input type="text" id="txtBusca" placeholder="&nbsp;&nbsp;&nbsp;BUSCA" />
                    <i className="fas fa-search" />
                  </div>
                </S.TitleAndSearch>
                <table style={{ flex: 1 }}>
                  <th>DATA</th>
                  <th>ORIGEM</th>
                  <th>REFERÊNCIA</th>
                  <th>VALOR</th>
                  <tr>
                    <td>Nenhum item encontrado</td>
                    {/* <td>FURADEIRA PHILCO</td>
                    <td>15058206987</td>
                    <td>-160,25</td> */}
                  </tr>
                  {/* <tr>
                    <td>18/06/2020</td>
                    <td>FURADEIRA PHILCO</td>
                    <td>15058206987</td>
                    <td>-160,25</td>
                  </tr>
                  <tr>
                    <td>18/06/2020</td>
                    <td>FURADEIRA PHILCO</td>
                    <td>15058206987</td>
                    <td>-160,25</td>
                  </tr>
                  <tr>
                    <td>18/06/2020</td>
                    <td>TORRADEIRA MONDAINE</td>
                    <td>15058206987</td>
                    <td>160,25</td>
                  </tr> */}
                </table>
                {/* <span> RESUMO DA MOVIMENTAÇÃO NO PERÍODO: 16/06/2020 - 16/07/2020 </span> */}
              </S.SecondaryTopLeftContainer>
              <S.SecondaryTopRightContainer>
                <h2>SALDO EM CONTA</h2>
                <h1>R$0,00</h1>
                <button>RESGATAR</button>
                <h3>ÚLTIMO SAQUE EFETUADO: 0,00</h3>
              </S.SecondaryTopRightContainer>
            </S.UserPaymentTopContainer>
            <S.UserPaymentTitle>
              <i className="fas fa-file-invoice" />
              Faturas
            </S.UserPaymentTitle>
            <S.UserPaymentBotContainer>
              <table>
                <th>NÚMERO</th>
                <th>DATA</th>
                <th>VALOR</th>
                <th>STATUS</th>
                <tr>
                  <td className="number">00004</td>
                  <td>03/08/2020</td>
                  <td>R$148,50</td>
                  <td className="status-no">Não Pago</td>
                  <button>VER MAIS {'>'}</button>
                </tr>
                <tr>
                  <td className="number">00003</td>
                  <td>03/07/2020</td>
                  <td>R$148,50</td>
                  <td className="status-no">Não Pago</td>
                  <button>VER MAIS {'>'}</button>
                </tr>
                <tr>
                  <td className="number">00002</td>
                  <td>03/06/2020</td>
                  <td>R$148,50</td>
                  <td className="status-yes">Pago</td>
                  <button>VER MAIS {'>'}</button>
                </tr>
                <tr>
                  <td className="number">00001</td>
                  <td>03/05/2020</td>
                  <td>R$148,50</td>
                  <td className="status-yes">Pago</td>
                  <button>VER MAIS {'>'}</button>
                </tr>
              </table>
              <span style={{ color: '#646161' }}>Ver todos</span>
            </S.UserPaymentBotContainer>
            <S.UserPaymentTitle>
              <i className="fas fa-file-invoice" />
              Planos
            </S.UserPaymentTitle>
            <S.PlansContainer>
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                <div
                  className="flex-full-center flex-column"
                  style={{ background: '#002666', borderRadius: 15 }}>
                  <div className="signup-mid-section" style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <div className="signup-mid">
                      {(plan === '' || plan === PLAN_TYPES.BASIC) && (
                        <div className="signup-plan-card" id="div_plan_basic">
                          <h3>Basic</h3>
                          <h2>
                            <span>R$</span>
                            1,00
                            <strong>/m</strong>
                          </h2>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p style={{ border: 'none' }}>Selecionar Duração:</p>
                          <br />
                          <div className="select-container">
                            <label>
                              <select
                                id="plan_basic"
                                onChange={(e) => setPlanDuration(e.target.value)}>
                                <option value={1}>1 mês - R$1,00/mês</option>
                                <option value={3}>3 meses - R$1,00/mês</option>
                                <option value={6}>6 meses - R$1,00/mês</option>
                              </select>
                              <i className="fas fa-chevron-down" />
                            </label>
                          </div>
                          <div className="flex-full-center">
                            <button
                              onClick={() => {
                                if (activeSub) return;
                                if (plan !== '') {
                                  setPlan('');
                                  setPlanDuration(1);
                                  updateSelectedPlanCss();
                                } else {
                                  setPlan(PLAN_TYPES.BASIC);
                                  setPlanDuration(document.getElementById('plan_basic').value);
                                  updateSelectedPlanCss('div_plan_basic');
                                }
                              }}
                              type="button">
                              ESCOLHER
                            </button>
                          </div>
                        </div>
                      )}
                      {(plan === '' || plan === PLAN_TYPES.STANDARD) && (
                        <div className="signup-plan-card" id="div_plan_standard">
                          <h3>Standard</h3>
                          <h2>
                            <span>R$</span>
                            29,99
                            <strong>/m</strong>
                          </h2>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p style={{ border: 'none' }}>Selecionar Duração:</p>
                          <br />
                          <div className="select-container">
                            <label>
                              <select
                                id="plan_standard"
                                onChange={(e) => setPlanDuration(e.target.value)}>
                                <option value={1}>1 mês - R$29,90/mês</option>
                                <option value={3}>3 meses - R$29,90/mês</option>
                                <option value={6}>6 meses - R$29,90/mês</option>
                              </select>
                              <i className="fas fa-chevron-down" />
                            </label>
                          </div>
                          <div className="flex-full-center">
                            <button
                              onClick={() => {
                                if (activeSub) return;
                                if (plan !== '') {
                                  setPlan('');
                                  setPlanDuration(1);
                                  updateSelectedPlanCss();
                                } else {
                                  setPlan(PLAN_TYPES.STANDARD);
                                  setPlanDuration(document.getElementById('plan_standard').value);
                                  updateSelectedPlanCss('div_plan_standard');
                                }
                              }}
                              type="button">
                              ESCOLHER
                            </button>
                          </div>
                        </div>
                      )}
                      {(plan === '' || plan === PLAN_TYPES.PREMIUM) && (
                        <div className="signup-plan-card" id="div_plan_premium">
                          <h3>Premium</h3>
                          <h2>
                            <span>R$</span>
                            39,90
                            <strong>/m</strong>
                          </h2>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p>Lorem Ipsum</p>
                          <p style={{ border: 'none' }}>Selecionar Duração:</p>
                          <br />
                          <div className="select-container">
                            <label>
                              <select
                                id="plan_premium"
                                onChange={(e) => setPlanDuration(e.target.value)}>
                                <option value={1}>1 mês - R$39,90/mês</option>
                                <option value={3}>3 meses - R$39,90/mês</option>
                                <option value={6}>6 meses - R$39,90/mês</option>
                              </select>
                              <i className="fas fa-chevron-down" />
                            </label>
                          </div>
                          <div className="flex-full-center">
                            <button
                              onClick={() => {
                                if (activeSub) return;
                                if (plan !== '') {
                                  setPlan('');
                                  setPlanDuration(1);
                                  updateSelectedPlanCss();
                                } else {
                                  setPlan(PLAN_TYPES.PREMIUM);
                                  setPlanDuration(document.getElementById('plan_premium').value);
                                  updateSelectedPlanCss('div_plan_premium');
                                }
                              }}
                              type="button">
                              ESCOLHER
                            </button>
                          </div>
                        </div>
                      )}
                      {plan !== '' && (
                        <div style={{ flex: 1, padding: 10 }}>
                          <h2 style={{ paddingLeft: 20, color: 'white' }}>
                            Selecione método de pagamento:
                          </h2>
                          <br />
                          <S.SecondaryTopLeftContainer style={{ width: '100%', height: '80%' }}>
                            {!selectedCard ? (
                              creditCards.map((card) => (
                                <>
                                  <CreditCard
                                    key={card.creditCardId}
                                    {...card}
                                    onSelect={() => setSelectedCard(card)}
                                    // onDelete={() => handleDeleteCreditCard(card.id)}
                                  />
                                  <VerSpacer size={10} />
                                </>
                              ))
                            ) : (
                              <>
                                <CreditCard
                                  key={selectedCard?.creditCardId}
                                  {...selectedCard}
                                  // onSelect={() => setSelectedCard(selectedCard)}
                                  onDelete={!activeSub ? () => setSelectedCard(null) : null}
                                />
                                <VerSpacer size={10} />
                                {activeSub ? (
                                  <>
                                    <p>Plano aderido:</p>
                                    <p>{plans[activeSub.planId].name}</p>
                                    <p>Data da próxima cobrança: {activeSub.nextBillingDate}</p>
                                    <p>Plano válido até {expirationDate}</p>
                                  </>
                                ) : (
                                  <>
                                    <p>Confirme seu plano:</p>
                                    <p>{plans[plan].name}</p>
                                    <p>
                                      Valor Total: R$
                                      {Number(plans[plan].amount * planDuration).toFixed(2)}
                                    </p>
                                    <p>Plano válido até {expirationDate}</p>
                                    <Button onClick={handleSign} type="button">
                                      Confirmar Assinatura
                                    </Button>
                                  </>
                                )}
                              </>
                            )}
                          </S.SecondaryTopLeftContainer>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </S.PlansContainer>
          </S.UserPaymentRightContainer>
        </S.UserSoldContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
};

export default UserPayment;
